import axios from "./axios";
export async function fetchCities() {
    try {
        const response =  await axios.get('/api/v1/cities')
        if(response?.status === 200) return response.data.data
        return []
    } catch (e) {
        console.error(e)
    }
}
